export class BusinessQr {
    public consumerId: number = 0;
    public urlQrPageRedirectsTo?: string;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): BusinessQr {
        const businessQr: BusinessQr = new BusinessQr();

        businessQr.consumerId = this.consumerId;
        businessQr.urlQrPageRedirectsTo = this.urlQrPageRedirectsTo;

        return businessQr;
    }
}
